import classNames from "classnames";
import { FontIconName, Icon } from "client/Components";
import { ReactElement } from "react";
import { LinkAudienceKind } from "./common";
import styles from "./LinkIcon.module.less";

export type LinkIconProps = {
	kind: LinkAudienceKind;
};

export const LinkIcon = (props: LinkIconProps): ReactElement => {
	const {
		kind
	} = props;

	const { modifier, icon } = kindToStylesMap[kind];

	return (
		<div
			className={classNames(
				styles.root,
				modifier
			)}
		>
			<Icon
				value={icon}
				size="large"
			/>
		</div>
	);
};
LinkIcon.displayName = "LinkIcon";

const kindToStylesMap: Record<LinkAudienceKind, { modifier: string; icon: FontIconName; }> = {
	[LinkAudienceKind.Anonymous]: {
		modifier: styles.root_anonymous,
		icon: "globe"
	},
	[LinkAudienceKind.Organization]: {
		modifier: styles.root_organization,
		icon: "briefcase"
	},
	[LinkAudienceKind.SpecificPeople]: {
		modifier: styles.root_specificPeople,
		icon: "user-plus"
	},
	[LinkAudienceKind.PeopleWithExistingAccess]: {
		modifier: styles.root_existingAccess,
		icon: "user-check"
	},
};
